import AddUserModal from './add-user-modal.vue'
export default AddUserModal
